<template>
  <v-container fluid class="claim-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/claim/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindClaim=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-2" @click="makeReimbursementList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Reimburse
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="claims-table"
              show-select
              v-model="data_seleted"
              item-key="_id"
              sort-desc
              sort-by="claimnum"
              :footer-props="footer"
              :headers="header_items"
              :items="data_claims"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteClaim"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Claim?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_claim.claimnum }} 
                      {{ delete_claim.claimname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteClaim = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_claim)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                <v-avatar v-if="item.employeeimage!=null && item.employeeimage!=''" size="40">
                  <img v-bind:src="item.employeeimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ item.employeename[0].toUpperCase() }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ item.employeename }} </span>
              </template>
              <template v-slot:item.claimnum="{ item }">
                <p class="two-line">{{ item.claimtype  }}</p>
                <p class="two-line">{{ item.claimnum  }}</p>
                <p class="two-line">{{ new Date(item.claimdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.claimaddress="{ item }">
                <p class="two-line">{{ item.claimaddress }}</p>
              </template>
              <template v-slot:item.claimstatus="{ item }">
                <v-chip
                  v-if="item.claimstatus!=undefined"
                  :color="getStatusColor(item.claimstatus)"
                  small
                >
                  {{ item.claimstatus }}
                </v-chip>
              </template>
              <template v-slot:item.claimtotal="{ item }">
                {{ item.claimtotal!=null ? item.claimtotal.toFixed(2) : '' }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.claimstatus=='New'" icon color="primary" @click="editClaimStatusDialog(item)">
                  <v-icon>mdi-text-box-edit-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.claimstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog
      v-model="isEditClaim"
      persistent
      width="400px"
      max-width="400px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Update Status</span>
        </v-card-title>
          <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-select
                  :items="claimstatus"
                  v-model="update_claim.claimstatus"
                  v-bind:error="errorindex == 11"
                  label="Status"
                  required
                ></v-select>
              </v-col>
                <v-col cols="12" md="12">
                <v-text-field
                  v-model="update_claim.claimreason"
                  v-bind:error="errorindex == 12"
                  :label="update_claim.claimstatus=='Approve' || update_claim.claimstatus=='Reject' ? update_claim.claimstatus + ' Reason' : 'Reason'"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditClaim = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editClaimStatus"
            >
              Save
            </v-btn>
          </v-card-actions>
         
      </v-card>
      </v-dialog>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isFindClaim"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Claims</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="employees.filter(x=>x.employeestatus=='Active' || x.employeestatus=='Contract').map(x => {
                              return {text: x.employeename, value: x._id};
                            })"
                    v-model="find_query.employeeid"
                    label="Employee"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="['New', 'Pending', 'Processing', 'Completed']"
                    v-model="find_query.claimstatus"
                    label="Claim Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.startdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="find_query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(find_query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindClaim = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findReset"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findClaims"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../../config";
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '@/util/tools';

export default {
  name: 'ClaimHrmList',
  data() {
    return {
      config,
      isDeleteClaim: false,
      isFindClaim: false,
      isEditClaim: false,
      menu_startdate: null,
      menu_enddate: null,
      error: undefined,
      haserror: false,
      errorindex: undefined,
      itemPerPage: 500,
      header_items: [
        { text: 'Claim', value: 'claimnum', sortable: false, 'width': '12%' },
        { text: 'Name', value: 'claimname' },
        { text: 'Employee', value: 'employeeid', 'width': '15%' },
        { text: 'Amount', value: 'claimtotal', 'width': '10%' },
        { text: 'Status', value: 'claimstatus', align: 'center', 'width': '10%' },
        { text: 'Actions', value: 'actions', sortable: false, 'width': '10%' },
      ],
      delete_claim: {},
      update_claim: {},
      find_query: {},
      claimstatus: ["Approve", "Reject"],
      data_seleted: [],
      data_claims: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('Claim', ['claims', 'isReceiving', 'isDeleting', 'isUpdating']),
    ...mapState('Employee', ['employees']),
  },
  methods: {
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('Claim', ["getClaimsRequest","findClaimsRequest","deleteClaimRequest","updateClaimStatusRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    checkError(){
      if(this.data_seleted.length==0) return false;
      if(this.data_seleted.find(item=>item.claimstatus=='New')!=null) return false;
      else if(this.data_seleted.find(item=>item.claimstatus=='Reject')!=null) return false;
      else if(this.data_seleted.find(item=>item.claimstatus=='Completed')!=null) return false;
      return true;
    },
    checkError1(){
      if(!this.update_claim.claimstatus){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.update_claim.claimreason){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkClaims(){
      return this.data_seleted.filter(item=>item.claimstatus=='New' || item.claimstatus=='Reject' || item.claimstatus=='Completed').map(item=>item.claimnum.toString()).join(', ');
    },
    editItem(item) {
      this.$router.push({ name: 'ClaimEdit', params: item })
    },
    makeReimbursementList(){
      if(!this.checkError()) {
        //if(this.data_seleted.length==0) this.dialogMessage='No Claims selected';
        //else this.dialogMessage='The following Claims cannot be reimbursed:  ' + this.checkClaims();
        //this.dialogAlert=true; 
        return;
      }
      let claims = Object.assign([], this.data_seleted);
      let json = {claims: claims, isClaims: true};
      this.$router.push({ name: 'ReimbursementAdd', params: json });
    },
    printItem(item) {
      let params = Object.assign({}, item);
      params.isFromAdm = true;
      this.$router.push({ name: 'ClaimPrint', params: params })
    },
    viewItem(item) {
      let params = Object.assign({}, item);
      params.isFromAdm = true;
      this.$router.push({ name: 'ClaimView', params: params })
    },
    async deleteItem(item) {
      let result = await this.deleteClaimRequest({_id: item._id});
      let index = this.data_claims.map(claim=>claim._id).indexOf(result._id);
      this.data_claims.splice(index, 1);
      this.isDeleteClaim = false;
    },
    deleteDialog(item) {
      this.isDeleteClaim = true;
      this.delete_claim = {
        _id: item._id,
        claimnum: item.claimnum,
        claimname: item.claimname,
      }
    },
    async findClaims(){
      this.isFindClaim = false;
      if(Object.keys(this.find_query).length==0){
        await this.getClaimsRequest();
        this.data_claims = Object.assign([], this.claims);
      }
      else{
        let result = await this.findClaimsRequest(this.find_query);
        this.data_claims = Object.assign([], result);
      }
    },
    async findReset(){
      this.find_query = {};

    },
    editClaimStatusDialog(item) {
      this.update_claim = {claimid: item._id};
      this.isEditClaim = true;
    },
    async editClaimStatus() {
      if(!this.checkError1()){return}
      this.isEditClaim = false;
      let result = await await this.updateClaimStatusRequest(this.update_claim);
      let index = this.data_claims.findIndex((claim) => claim._id == result._id);
      this.data_claims.splice(index, 1, result);
      
    },
  },
  async created () {
    await this.getClaimsRequest();
    this.data_claims = Object.assign([], this.claims);
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
